module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/noGamesIcons/noGames/nba/survive_wt-3be79e637bdbd44df396f6aedcd20731.svg";